import React from 'react';
import './bookAppointmentButton.scss';
import { useTranslation } from 'react-i18next';
// import ReactGA from 'react-ga4';

const BookAppointmentButton = () => {
  const { t, i18n } = useTranslation();

  const currentLang = i18n.language;

  const appointmentLinks = {
    en: 'https://calendly.com/d/ctgh-ryy-5kx',
    ru: 'https://calendly.com/d/ctgh-ryy-5kx',
    hy: 'https://calendly.com/d/ctgh-ryy-5kx',
    es: 'https://calendly.com/d/ctgh-ryy-5kx',
  };

  const appointmentUrl = appointmentLinks[currentLang] || appointmentLinks.en;

  const label = t('appointment', { defaultValue: 'Book Appointment' });

  return (
    <div className="bookAppointmentButton">
      <a
        id="appointmentButton"
        href={appointmentUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={label}
        onClick={() => {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'appointment_click',
            page_path: window.location.pathname,
            language: currentLang,
          });
        }}
      >
        {label}
      </a>
    </div>
  );
};

export default BookAppointmentButton;
